import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_s_page = _resolveComponent("s-page")!

  return (_openBlock(), _createBlock(_component_s_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_s_btn, {
        icon: "img:images/logo-ethnoportal.svg",
        "icon-right": "app:arrow-normal-right",
        label: "Перейти в Этно Портал",
        type: "secondary",
        class: "s-btn__ethnoportal q-mb-md",
        onClick: _ctx.redirectToEthnoportal
      }, null, 8, ["onClick"]),
      _createElementVNode("iframe", {
        class: "language-center--iframe",
        width: "100%",
        height: "850px",
        src: _ctx.getIframeUrl
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}